import { IconDoor } from '@tabler/icons-react'
import { Tooltip } from 'antd'

import { Tag } from '@/components/shared-components/BUI/Tag'

import { ProjectLocationLike } from 'types/vagueTypes'

type LocationInfo = { name: string }

export const getLocationHierarchy = (
  location: ProjectLocationLike,
  locations: LocationInfo[] = []
): LocationInfo[] => {
  if (!location) return locations

  locations.push({ name: location.name })

  if (location.parent) {
    getLocationHierarchy(location.parent, locations)
  }

  return locations
}

export const getLocationHierarchyText = (
  location: ProjectLocationLike,
  reverse = true
): string => {
  const locationHierarchy = getLocationHierarchy(location)

  const hierarchy = reverse ? locationHierarchy.reverse() : locationHierarchy
  return hierarchy.map((loc) => loc.name).join(' > ')
}

export const getLocationHierarchyTooltip = (
  location: ProjectLocationLike,
  showIcon = false
): React.ReactNode => {
  if (!location) return null

  if (!location.parent)
    return (
      <Tag
        size="small"
        label={location.name}
        icon={showIcon ? <IconDoor size={16} /> : undefined}
      />
    )

  return (
    <Tooltip title={getLocationHierarchyText(location)}>
      <Tag
        size="small"
        label={location.name}
        icon={showIcon ? <IconDoor size={16} /> : undefined}
      />
    </Tooltip>
  )
}
